<div class="breadcrumb-bar" *ngIf="isEnabled">
  <ul class="breadcrumb">
    <li *ngFor="let part of routeParts"><a routerLink="/{{part.url}}">{{part.breadcrumb }}</a></li>
  </ul>
</div>
 